/* Raw Water Co. v2 — buy-box one-time/subscribe toggle.
   Toggles the active option, shows the frequency selector, and enables/disables
   the selling_plan field so the box adds as one-time or subscription.
   CRV is added alongside automatically by rwc-crv-sync.js (it intercepts the
   product-form submit and mirrors qty + selling plan). */
(function () {
  function init(form) {
    if (!form || form.dataset.v2Init) return;
    form.dataset.v2Init = "1";

    var options = form.querySelectorAll(".v2-option");
    var freq = form.querySelector(".v2-buybox__freq");
    var select = freq ? freq.querySelector("select") : null;

    function selectOption(which) {
      options.forEach(function (o) {
        var isThis = o.getAttribute("data-v2-option") === which;
        o.classList.toggle("v2-option--active", isThis);
        var radio = o.querySelector('input[type="radio"]');
        if (radio) radio.checked = isThis;
      });
      var subscribe = which === "subscribe";
      if (freq) freq.hidden = !subscribe;
      if (select) select.disabled = !subscribe; // disabled select is omitted -> one-time
    }

    options.forEach(function (o) {
      o.addEventListener("click", function (e) {
        e.preventDefault();
        selectOption(o.getAttribute("data-v2-option"));
      });
    });
  }

  function initAll() {
    document.querySelectorAll(".v2-buybox__form").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
